/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-north-1",
    "aws_appsync_graphqlEndpoint": "https://jqicdf3rkrcs7gesue3flieeru.appsync-api.eu-north-1.amazonaws.com/graphql",
    "aws_appsync_region": "eu-north-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-6qmw6vezwjhnvkw5oflzvq6dcq",
    "aws_cloud_logic_custom": [
        {
            "name": "zeeepyApi",
            "endpoint": "https://ldai0gdktb.execute-api.eu-north-1.amazonaws.com/staging",
            "region": "eu-north-1"
        }
    ],
    "aws_cognito_identity_pool_id": "eu-north-1:fefdabd7-da3a-485c-920e-fcc6af0dd871",
    "aws_cognito_region": "eu-north-1",
    "aws_user_pools_id": "eu-north-1_BrN6iEjru",
    "aws_user_pools_web_client_id": "26qfndbjvi8s7n1b0k0uukavt5",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "zeeepy-storage-1e66f5bd191850-staging",
    "aws_user_files_s3_bucket_region": "eu-north-1"
};


export default awsmobile;
